import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import {
  Modal,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
  FormLabel,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { MEMBERSHIP_TYPE } from "../utils/enums";
import { isNumber, isValidNumber } from "../utils/validations";

interface CommissionOfferModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setMembershipStatus: Dispatch<SetStateAction<string>>;
  membershipStatus: string;
  setTrialDate: Dispatch<SetStateAction<Dayjs | null>>;
  trialDate: Dayjs | null;
  setCompDate: Dispatch<SetStateAction<Dayjs | null>>;
  compDate: Dayjs | null;
  onClick: () => void;
  memberType: string;
  handleShortcut?: any;
  setSelectedShortcut: Dispatch<SetStateAction<string | null>>;
  selectedShortcut: null | string;
  subscription: any;
  setSelectedSubscription: Dispatch<SetStateAction<string>>;
  selectedSubscription: string;
  amount: string;
  setAmount: Dispatch<SetStateAction<string>>;
  validFor: string;
  setValidFor: Dispatch<SetStateAction<string>>;
  updateOption: string;
  setUpdateOption: Dispatch<SetStateAction<string>>;
}

export default function MembershipStatusModal({
  open,
  onClose,
  setOpen,
  setMembershipStatus,
  membershipStatus,
  onClick,
  trialDate,
  setTrialDate,
  compDate,
  setCompDate,
  memberType,
  handleShortcut,
  selectedShortcut,
  setSelectedShortcut,
  subscription,
  setSelectedSubscription,
  selectedSubscription,
  amount,
  setAmount,
  validFor,
  setValidFor,
  updateOption,
  setUpdateOption,
}: CommissionOfferModalProps) {
  const [subName, setSubName] = useState("");

  return (
    <Modal className="modal membership_modal" open={open} onClose={onClose}>
      <div className="modal-dialog" style={{ minWidth: "60%" }}>
        <div className="modal-body">
          <div className="modal_title">
            <h2>Please update the status of Membership</h2>

            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <Button className="btn btn_primary" onClick={onClick}>
                Proceed
              </Button>

              <div
                className="btn-close"
                onClick={() => {
                  setCompDate(null);
                  setTrialDate(null);
                  setMembershipStatus("Trial");
                  setOpen(false);
                  setAmount("");
                  setValidFor("");
                  setSelectedSubscription("");
                  setUpdateOption("no");
                }}
              >
                <CloseIcon />
              </div>
            </div>
          </div>

          <form className="form" action="">
            <FormControl fullWidth>
              <RadioGroup
                name="membership-radio-group"
                value={membershipStatus}
                onChange={(e) => {
                  setSelectedShortcut("");
                  setCompDate(null);
                  setTrialDate(null);
                  setMembershipStatus(e.target.value);
                }}
              >
                {/* Trial */}
                <div className="control_group">
                  <div className="lt">
                    <FormControlLabel
                      value="Trial"
                      control={<Radio />}
                      label="Trial"
                    />
                  </div>
                  <div className="rt">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <label style={{ minWidth: "40px" }}>Date</label>
                      {membershipStatus !== MEMBERSHIP_TYPE.TRAIL ? null : (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            marginBottom: "10px",
                            flexWrap: "wrap",
                          }}
                        >
                          {["1w", "1m", "3m", "6m", "1y", "10y"]?.map(
                            (item) => (
                              <button
                                key={item}
                                type="button"
                                onClick={() => {
                                  handleShortcut(item, membershipStatus);
                                  setSelectedShortcut(item);
                                }}
                                disabled={membershipStatus !== "Trial"}
                                style={{
                                  borderRadius: "50px",
                                  padding: "5px 10px",
                                  backgroundColor:
                                    selectedShortcut === item
                                      ? "#BC8F4B"
                                      : "#f0f0f0",
                                  border: "none",
                                }}
                              >
                                {item
                                  .replace("w", " Week")
                                  .replace("m", " Month")
                                  .replace("y", " Year")}
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </div>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        value={trialDate}
                        onChange={(newValue) => setTrialDate(newValue)}
                        minDate={dayjs()}
                        disabled={membershipStatus !== MEMBERSHIP_TYPE.TRAIL}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: "Select",
                            hiddenLabel: true,
                          },
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>
                </div>

                {/* Complementary */}
                <div className="control_group">
                  <div className="lt">
                    <FormControlLabel
                      value="Complementary"
                      control={<Radio />}
                      label="Complementary"
                    />
                  </div>
                  <div className="rt">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <label style={{ minWidth: "40px" }}>Date</label>
                      {membershipStatus !==
                      MEMBERSHIP_TYPE.COMPLIMENTARY ? null : (
                        <div
                          style={{
                            display: "flex",
                            gap: "6px",
                            marginBottom: "10px",
                            flexWrap: "wrap",
                          }}
                        >
                          {["1w", "1m", "3m", "6m", "1y", "10y"]?.map(
                            (item) => (
                              <button
                                key={item}
                                type="button"
                                onClick={() => {
                                  handleShortcut(item, membershipStatus);
                                  setSelectedShortcut(item);
                                }}
                                style={{
                                  borderRadius: "50px",
                                  padding: "5px 10px",
                                  backgroundColor:
                                    selectedShortcut === item
                                      ? "#BC8F4B"
                                      : "#f0f0f0",
                                  border: "none",
                                }}
                              >
                                {item
                                  .replace("w", " Week")
                                  .replace("m", " Month")
                                  .replace("y", " Year")}
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="form_control"
                        value={compDate}
                        disabled={
                          membershipStatus !== MEMBERSHIP_TYPE.COMPLIMENTARY
                        }
                        onChange={(newValue) => setCompDate(newValue)}
                        minDate={dayjs()}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            placeholder: "Select",
                            hiddenLabel: true,
                          },
                        }}
                        desktopModeMediaQuery="(min-width:0px)"
                      />
                    </LocalizationProvider>
                  </div>
                </div>

                {/* Paid */}
                <div className="control_group">
                  <div className="lt">
                    <FormControlLabel
                      value="Paid"
                      control={<Radio />}
                      label="Paid"
                    />
                  </div>
                  <div
                    className="rt"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "20px",
                    }}
                  >
                    <div className="rt">
                      <FormLabel className="form_label">Type</FormLabel>
                      <p>{memberType || "-"}</p>
                    </div>
                    {membershipStatus === "Paid" ? (
                      <div className="rt">
                        <FormLabel className="form_label">
                          Update Membership?
                        </FormLabel>
                        <div className="control_group" style={{ margin: "0" }}>
                          <FormControl
                            className="m_radio"
                            disabled={!memberType}
                          >
                            <RadioGroup
                              aria-labelledby="demo-radio-buttons-group-label"
                              defaultValue="female"
                              name="radio-buttons-group"
                              value={updateOption}
                              onChange={(e) => setUpdateOption(e.target.value)}
                            >
                              <FormControlLabel
                                value="yes"
                                control={<Radio />}
                                label="Yes"
                                className="small-label"
                                sx={{
                                  "&.Mui-disabled": {
                                    color: "rgba(255, 255, 255, 0.3)",
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: "rgba(255, 255, 255, 0.3)",
                                  },
                                }}
                              />
                              <FormControlLabel
                                value="no"
                                control={<Radio />}
                                label="No"
                                className="small-label"
                                sx={{
                                  "&.Mui-disabled": {
                                    color: "rgba(255, 255, 255, 0.3)",
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: "rgba(255, 255, 255, 0.3)",
                                  },
                                }}
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </RadioGroup>
            </FormControl>

            {updateOption === "yes" ? (
              <div className="gap_p">
                <div className="control_group w_33">
                  <Select
                    fullWidth
                    value={selectedSubscription}
                    onChange={(e) => {
                      setSelectedSubscription(e.target.value);
                      const sub = subscription.find(
                        (s: any) => s.id === e.target.value
                      );
                      setAmount(sub?.price || "");
                      setSubName(sub?.memberShipPlan || "-");
                    }}
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                      Select Subscription
                    </MenuItem>
                    {subscription
                      ?.filter((cat: any) => cat.memberShipType === memberType)
                      .map((cat: any) => (
                        <MenuItem key={cat?.id} value={cat?.id}>
                          {cat?.memberShipPlan || "-"}
                        </MenuItem>
                      ))}
                  </Select>
                </div>

                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder="Amount"
                    fullWidth
                    hiddenLabel
                    disabled={!selectedSubscription}
                    value={amount}
                    inputProps={{ maxLength: 10 }}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (isValidNumber(value)) {
                        setAmount(value);
                      }
                    }}
                  />
                </div>

                <div className="control_group w_33">
                  <TextField
                    variant="outlined"
                    placeholder={`Valid for ${subName === "Annually" ? "( Years )" : subName === "Monthly" ? "( Months )" : subName === "Quarterly" ? "( 3 Months )" : subName === "SemiAnnually" ? "( 6 Months )" : ""}`}
                    fullWidth
                    disabled={!selectedSubscription}
                    hiddenLabel
                    value={validFor}
                    inputProps={{ maxLength: 10 }}
                    onChange={(e) => {
                      const { value } = e.target;
                      if (isNumber(value)) {
                        setValidFor(value);
                      }
                    }}
                  />
                </div>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    </Modal>
  );
}
